import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Col } from 'react-bootstrap';

// Components
import Payout from '../../components/Payout';

import cs from '../../components/commonStyle.css'
import s from './PayoutContainer.css';

const PayoutContainer = (props) => {

  const { title, currentAccountId } = props;
  return (
    <>
      <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
        <Payout currentAccountId={currentAccountId} />
      </Col>
    </>
  );
}

PayoutContainer.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s, cs)(PayoutContainer);